/** Mashg'ulot ekrani (demo `sess` + `step`): `.sbar` (×, progress, pos/total), `.stg` bosqich nuqtalari, joriy qadam. */
import { useEffect } from 'react';
import { t } from '../../i18n';
import { releaseMic } from '../../lib/recorder';
import { Ic } from '../../ui/Icon';
import { lessonTotal, quit, STAGES, useLesson, type Step } from './engine';
import { CardStep, FlipStep } from './steps/Card';
import { ChoiceStep } from './steps/Choice';
import { GapStep } from './steps/Gap';
import { IntroStep } from './steps/Intro';
import { MatchStep } from './steps/Match';
import { SpeakStep } from './steps/Speak';
import { WriteStep } from './steps/Write';

function StepView({ s }: { s: Step }) {
  switch (s.t) {
    case 'intro': return <IntroStep s={s} />;
    case 'card': return <CardStep s={s} />;
    case 'flip': return <FlipStep s={s} />;
    case 'rec': case 'recUz': case 'listen': return <ChoiceStep s={s} />;
    case 'write': return <WriteStep s={s} />;
    case 'speak': return <SpeakStep s={s} />;
    case 'gap': return <GapStep s={s} />;
    case 'match': return <MatchStep s={s} />;
  }
}

export function Lesson() {
  const L = useLesson((st) => st.L);
  useEffect(() => releaseMic, []); // darsdan chiqqanda mikrofon yopiladi
  if (!L) return null;
  const s = L.steps[L.i];
  if (!s) return null;
  // dars: har bir bosqich alohida sanaladi
  const stg = L.mode === 'lesson' && s.stage != null ? s.stage : null;
  let total = lessonTotal(L), pos = L.i;
  if (stg != null) {
    const idx = L.steps.map((x, i) => (x.stage === stg && x.t !== 'intro' ? i : -1)).filter((i) => i >= 0);
    total = idx.length; pos = Math.max(0, idx.indexOf(L.i));
  }
  const p = total ? Math.round(pos / total * 100) : 0;
  return (
    <>
      <div className="sbar">
        <button className="x" id="quit" aria-label={t('Chiqish')} onClick={quit}><Ic n="x" /></button>
        <div className="trk"><i style={{ width: `${p}%` }} /></div>
        <b>{Math.min(pos + 1, total)}/{total}</b>
      </div>
      {stg != null && (
        <div className="stg">
          <div className="dots">{STAGES.map((_, i) => <i key={i} className={i < stg ? 'done' : i === stg ? 'on' : ''} />)}</div>
          <span>{stg + 1}/5 · {t(STAGES[stg]!.n)}</span>
        </div>
      )}
      <StepView key={L.i} s={s} />
    </>
  );
}
